import { __assign } from "tslib";
import { namespacedClassnames } from '../../../common/namespace-classes';
import * as React from 'react';
import { ReactSelect3, ReactSelect3Components } from './../../../common/react-select';
import { LibColor } from '../../../new-libby';
import { menuFooterStyle, selectV3Styles } from '../select-v3-styles';
import { getChevronIcon } from '../chevron-icon';
import { Icon } from '../../../primitives/icon/icon';
import { iconsMap } from '../../../icons';
import { useOnScroll } from '../../../common/hooks';
export var MultiSelect = function (props) {
    var refSelectV3 = React.useRef(null);
    var onInputChange = function (term) {
        if (props.onInputChange) {
            props.onInputChange(term);
        }
    };
    var formatOptionLabel = function (data, labelMeta) {
        var _a;
        if (labelMeta.context === 'menu') {
            var isSelected = !!((_a = labelMeta === null || labelMeta === void 0 ? void 0 : labelMeta.selectValue) === null || _a === void 0 ? void 0 : _a.find(function (value) { return value.value === data.value; }));
            var optionState = { isSelected: isSelected };
            return props.optionRenderer ? props.optionRenderer(data, optionState) : data.label;
        }
        else {
            return props.valueRenderer ? props.valueRenderer(data) : data.label;
        }
    };
    var defaultV3Props = {
        disabled: false,
        searchable: true,
        openMenuOnFocus: true,
        clearable: false,
        autosize: false
    };
    // avoids the Menu from opening again because clicking on the Footer is still considered a focus event
    var onClickFooter = function (e) {
        var _a, _b;
        var footerCompClass = (_a = e.target) === null || _a === void 0 ? void 0 : _a.classList.value;
        if (refSelectV3.current) {
            // checks if footer comp is a link
            if (!(footerCompClass === null || footerCompClass === void 0 ? void 0 : footerCompClass.includes('aul link'))) {
                e.preventDefault();
                e.stopPropagation();
            }
            (_b = refSelectV3.current) === null || _b === void 0 ? void 0 : _b.blur();
        }
    };
    var DropdownIndicator = function (dropdownProps) {
        return (React.createElement(ReactSelect3Components.DropdownIndicator, __assign({}, dropdownProps), getChevronIcon(!!props.disabled)));
    };
    var renderMenuFooter = function (menuProps) {
        if (props.menuFooter) {
            var isMenuPlacementTop = menuProps.menuPlacement === 'top' ? true : false;
            var menuFooterComp = (React.createElement("div", { className: 'select-menu-footer', style: menuFooterStyle(isMenuPlacementTop), onClick: onClickFooter }, props.menuFooter));
            return isMenuPlacementTop ? (React.createElement(React.Fragment, null,
                menuFooterComp,
                menuProps.children)) : (React.createElement(React.Fragment, null,
                menuProps.children,
                menuFooterComp));
        }
        else {
            return menuProps.children;
        }
    };
    var Menu = function (menuProps) {
        var _a = useOnScroll(), scrolled = _a[0], onScroll = _a[1];
        return (React.createElement(ReactSelect3Components.Menu, __assign({}, menuProps),
            React.createElement("div", { className: namespacedClassnames({ scrolled: scrolled }), onScroll: onScroll }, renderMenuFooter(menuProps))));
    };
    var IndicatorSeparator = function (_) { return null; };
    var NoOptionsMessage = function (props) {
        var noOptionStyle = { fontSize: '14px', fontWeight: 300, padding: '6px 12px', color: "" + LibColor.grey100 };
        var noResultsTextElem = typeof props.noResultsText === 'string'
            ? React.createElement("div", { className: 'no-results-v3', style: noOptionStyle }, props.noResultsText)
            : props.noResultsText;
        return React.createElement(ReactSelect3Components.NoOptionsMessage, __assign({}, props), noResultsTextElem);
    };
    var MultiValueRemove = function (props) {
        return React.createElement(ReactSelect3Components.MultiValueRemove, __assign({}, props),
            React.createElement(Icon, { color: LibColor.grey70, icon: iconsMap.mediumThinX }));
    };
    var maybeMenuPortal = props.bringMenuToFront ? {
        menuPortalTarget: document.body,
    } : {};
    var Option = function (optionProps) {
        return React.createElement(ReactSelect3Components.Option, __assign({}, optionProps, { className: optionProps.data.className }));
    };
    var classNamesV3 = namespacedClassnames('multi-select-v3', props.className);
    var hideSelectedOptions = props.hideSelectedOptions !== undefined ? props.hideSelectedOptions : true;
    return (React.createElement(ReactSelect3, __assign({}, defaultV3Props, maybeMenuPortal, { ref: refSelectV3, isMulti: true, value: props.value, options: props.options, onChange: props.onChange, placeholder: props.placeholder, isDisabled: !!props.disabled, classNamePrefix: 'select-v3', className: classNamesV3, isClearable: false, components: __assign({ Option: Option, Menu: Menu, MultiValueRemove: MultiValueRemove, NoOptionsMessage: NoOptionsMessage, IndicatorSeparator: IndicatorSeparator, DropdownIndicator: DropdownIndicator }, props.components), styles: selectV3Styles('normal', props.menuPlacement, true), 
        // blurInputOnSelect={true} - DONT PASS THIS as it conflicts with openMenuOnFocus
        onMenuOpen: props.onOpen, onMenuClose: props.onClose, onInputChange: onInputChange, hideSelectedOptions: hideSelectedOptions, formatOptionLabel: formatOptionLabel, menuPlacement: props.menuPlacement, filterOption: props.disableOptionFiltering ? function () { return true; } : undefined, menuShouldScrollIntoView: true, maxMenuHeight: 172, onKeyDown: props.onKeyDown })));
};
//# sourceMappingURL=index.js.map